import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'account-settings-profile',
		path: '/account_settings/profile',
		component: loadable(async () => import(/* webpackChunkName: "pages/account_settings_profile" */ './index'), {
			exportName: 'AccountSettingsProfile',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
		},
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
